export function notNull(object: any): boolean {
    return object !== null && object !== undefined;
}
